<template>
  <div class="products-list">
    <ProductCard
      v-for="product in products"
      :key="product.id"
      :product="product"
    />
  </div>
</template>

<script>
import ProductCard from "@/components/dashboard/ProductCard.vue";
export default {
  name: "ProductsList",
  components: {
    ProductCard,
  },
  computed: {
    products() {
      return this.$store.getters["dashboard/getProduct"];
    },
  },
};
</script>
